import { useTranslation } from "react-i18next";
import { createPortal } from "react-dom";
import { useEffect, useState } from "react";

export default function TermsAndConditionsModal({ onClose }: { onClose?: () => void }) {
  const {t} = useTranslation(); 
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const bullets = [
    "Appointments are non-refundable.",
    "Appointments cannot be transferred to another person.",
    "The appointment is valid only for the specific service you have booked.",
    "You may only book Three service per appointment.",
    "A valid ID must be presented at the time of the appointment.",
    "You must arrive on time for your appointment.",
    "If you are late, we reserve the right not to serve you.",
  ];

  if (!mounted) return null;

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/15 backdrop-blur-sm p-4 transition-all duration-300" onClick={onClose}>
      <div className="w-full max-w-md animate-in zoom-in-95 duration-300" onClick={(e) => e.stopPropagation()}>
        {/* Card */}
        <div className="bg-white rounded-3xl shadow-2xl p-8 relative overflow-hidden">
          {/* Decorative background element */}
          <div className="absolute top-0 right-0 w-32 h-32 bg-pink-50 rounded-full -mr-16 -mt-16 blur-2xl pointer-events-none" />
          
          {onClose && (
            <button 
              onClick={onClose}
              className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 text-gray-400 hover:bg-gray-200 hover:text-gray-600 transition-colors"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            </button>
          )}
          
          <div className="relative z-10">
            <div className="flex gap-3 mb-3">
              <div className="w-12 h-12 bg-pink-100 rounded-2xl flex items-center justify-center mb-4 text-pink-600 rotate-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
              </div>
              
              <div className="">
                <h1 className="font-bold text-xl text-gray-900 mb-1">
                  <div>{t("Appointment Policy Consent")}</div>
                </h1>
                <p className="text-sm text-gray-500 mb-6">{t("Please review our terms before proceeding.")}</p>
              </div>
            </div>

            <ul className="space-y-4">
              {bullets.map((b, i) => (
                <li key={i} className="flex gap-3 items-start group">
                  <div className="mt-1.5 w-1.5 h-1.5 rounded-full bg-pink-500 flex-shrink-0 shadow-[0_0_0_4px_rgba(236,72,153,0.2)] group-hover:scale-110 transition-transform" />
                  <span className="text-sm text-gray-600 leading-relaxed font-medium">{t(b)}</span>
                </li>
              ))}
            </ul>
            
            <div className="mt-8 pt-6 border-t border-gray-100">
              <button 
                onClick={onClose}
                className="w-full h-12 rounded-full bg-pink-600 text-white text-sm font-bold hover:bg-pink-700 hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200 active:scale-95"
              >
                {t("I Understand")}
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>,
    document.body
  )
}